import { diffJson } from 'diff';
export const serializeAllProducts = (coreApi) => coreApi.getServices().serializer.hierarchiesToJsonString(coreApi.entities.getAll());
export const compareSerializedStates = (s1, s2) => {
    const diff = diffJson(s1, s2);
    const changes = diff.filter(e => e.added || e.removed).length;
    return { diff, changes };
};
//# sourceMappingURL=states.js.map